import { useTranslation } from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/dropdown-menu';
import useDestination from '@/hooks/use-destination.hook';

const LanguageSwitcher = (): React.JSX.Element => {
  const { i18n } = useTranslation();
  const { getLanguageFlagIcon } = useDestination();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <img
          src={getLanguageFlagIcon(i18n.language)}
          alt={i18n.language}
          className="w-6 h-6 rounded-full object-cover border-0 shadow-md cursor-pointer"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-10 min-w-10 max-w-10 bg-white text-grayish">
        {(i18n.options.supportedLngs || [])
          .filter(lng => lng !== 'cimode')
          .map(lng => (
            <DropdownMenuItem
              key={lng}
              onClick={() => i18n.changeLanguage(lng)}
              className="cursor-pointer px-0 justify-center"
            >
              <img
                src={getLanguageFlagIcon(lng)}
                alt={lng}
                className="w-4 h-4 rounded-full object-cover"
              />
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
